module.exports = __webpack_public_path__ + "img/sport-11-@1x.1a62a6ab.png";